<template>
    <div class="d-contents">
        <tr
            v-for="key in Array.from(Array(rowCount).keys())"
            :key="`row-${key}`"
        >
            <th
                v-for="desktopKey in Array.from(Array(desktopCount).keys())"
                :key="`desktop-${desktopKey}`"
                class="is-hidden-touch"
            >
                <b-skeleton
                    width="50%"
                    size="is-medium"
                />
            </th>
            <th
                v-for="tabletKey in Array.from(Array(tabletCount).keys())"
                :key="`tablet-${tabletKey}`"
                class="is-hidden-mobile is-hidden-desktop"
            >
                <b-skeleton
                    width="60%"
                    size="is-medium"
                />
            </th>
            <th
                v-for="mobileKey in Array.from(Array(mobileCount).keys())"
                :key="`mobile-${mobileKey}`"
                class="is-hidden-tablet"
            >
                <b-skeleton
                    width="90%"
                    size="is-medium"
                />
            </th>
        </tr>
    </div>
</template>

<script>
export default {
    props: {
        rowCount: {
            type: Number,
            required: false,
            default: 1,
        },
        desktopCount: {
            type: Number,
            required: true,
        },
        tabletCount: {
            type: Number,
            default: 0,
        },
        mobileCount: {
            type: Number,
            default: 0,
        },
    },
};
</script>
